import { apiV1, apiV2 } from "@/store";

const state = {
  invalidPromotion: false,
  reservationsLoading: false,
  reservations: []
};

const actions = {
  getReservations: ({ commit, state, dispatch }, payload) => {
    commit("invalidPromotion", false);
    state.reservationsLoading = true;
    return apiV2.get(
      `facilities/${payload.facilityId}/reservations`,
      {
        params: {
          with: [
            "promotion"
          ]
        }
      })
      .then(resp => {
        state.reservations = resp.data;
      })
      .catch(err => {
        dispatch("handleError", err);
      }).finally(() => {
        state.reservationsLoading = false;
      });
  },

  createReservation: ({}, payload) => {
    return new Promise((resolve, reject) => {
      apiV2.post(`facilities/${payload.facility_id}/reservations`, payload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getNotes: ({}, payload) => {
    return new Promise((resolve, reject) => {
      apiV2.get(`facilities/${payload.facility_id}/reservations/${payload.waiting_list_id}/notes`, {
        params: {
          select: [
            "description",
            "created_at"
          ]
        }
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  addNote: ({}, payload) => {
    return new Promise((resolve, reject) => {
      apiV2.post(`facilities/${payload.facility_id}/reservations/${payload.waiting_list_id}/notes`, payload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  manualConversion: ({}, payload) => {
    return new Promise((resolve, reject) => {
      apiV1.patch(`reservations/${payload.reservationId}/convert`, payload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updateReservation: ({}, payload) => {
    return new Promise((resolve, reject) => {
      apiV2.patch(`facilities/${payload.facilityId}/reservations/${payload.waitingListId}`, payload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  createLeaseSignatureRequest: ({}, payload) => {
    return new Promise((resolve, reject) => {
      apiV2.post(`facilities/${payload.facilityId}/esign/signature-requests/lease`, payload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

const mutations = {
  invalidPromotion(state, invalid) {
    state.invalidPromotion = invalid;
  },
  setReservationsLoading(state, loading) {
    state.reservationsLoading = loading;
  }
};

export default {
  state,
  actions,
  mutations
};
